export default __webpack_public_path__ + "cover.658a2cf6a5a38eef7631077da796819d.jpg"